import Component from './component';
import Module from './module';

import HTMLClass from './utils/HTMLClass';

const components = [];

/**
 * Class App
 */
class App {
	/**
	 * Init default DOM, empty objects events, modules and mount event od body
	 */
	constructor() {
		this.dom = {
			$body: document.querySelectorAll('body')[0],
			$html: document.querySelectorAll('html')[0],
			$window: window
		};
        this.events = {};
		this._modules = {};
		this._assets = {
			'js': [],
			'css': [],
		}
        this._initEvents();

		/*this.dom.$window.addEventListener('domready', () => {
            HTMLClass.addClass(this.dom.$body, 'kr_domready');
        });

        this.dom.$window.onload = () => {
            HTMLClass.addClass(this.dom.$body, 'kr_domloaded');
        };*/
	}

	/**
	 * Run framework
	 */
	run() {
		this.tick(this.dom.$body);
		this.initModules();
		this.dom.$window.dispatchEvent(this.events['domready']);
	}

	/**
	 * init modules to _modules object
	 */
	initModules() {
		for (let i in this._modules) {
			this._modules[i].init();
		}
	}

	/**
	 * Initialize all components
	 * @param {object} $context HTML DOM - parent
	 */
	tick($context) {
		for (let key in components) {
			const component = components[key];
			this.initializeComponent(key, $context.querySelectorAll(component['selector']));
		}
	}

	/**
	 * Initialize Component
	 * @param {string} selector attribute, id, tagname or class to get element
	 * @param {object} $context HTML NodeList - all elements from tick
	 */
	initializeComponent(selector, $context) {
		for (let key in $context) {
			if ($context.hasOwnProperty(key) && $context[key][selector] === undefined) {
				new components[selector].meta.component($context[key], {}, this);
				//$context[key][selector] = ;
			}
		}
	}

	/**
	 * Reinit specyfic component
	 * @param {String} name  - component name
	 * @returns 
	 */
	reInitComponent(name) {
		const index = components.findIndex(item => item.meta.name == name);
		if (index == -1) {
			console.warn(`Component ${name} not found`);
			return
		}
		
		const component = components[index];
		const $context = this.dom.$body;
		this.initializeComponent(index, $context.querySelectorAll(component['selector'])); 
	}

	/**
	 * Tell framework to use module
	 * @param {string} name unique module name
	 * @param {class} module class module
	 */
	use(name, module) {
		this._modules[name] = new module(this);
		return this._modules[name];
	}

	/**
	 * Return module object
	 * @param {string} name unique module name
	 */
	getModule(name) {
		return this._modules[name];
    }
	
	/**
	 * Public function to add new events
	 * @param {string} event 
	 */
	addEvent(event) {
		if (typeof this.events[event] !== 'undefined') {
			return;
		}

		this.events[event] = new Event(event);
	}

	/**
	 * Public function to get event by name
	 * @param {string} event 
	 */
	getEvent(event) {
		if (typeof this.events[event] === 'undefined') {
			return;
		}

		return this.events[event];
	}

	/**
	 * Public functon to add Css
	 * @param {string} fileName 
	 */
	addCss(fileName, callback = null) {
		if (this._assets.css.indexOf(fileName) !== -1) {
			if (callback) {
				callback();
			}
			return;
		}
		const head = document.head;
		const link = document.createElement('link');
		
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = fileName;
		
		head.appendChild(link);
		link.onload = () => {
			if (callback) {
				callback();
			}
		};
		this._assets.css.push(fileName);
	}

	/**
	 * Public functon to add JS
	 * @param {string} fileName 
	 */
	addJs(fileName, footer = false, callback = null) {
		if (this._assets.js.indexOf(fileName) !== -1) {
			if (callback) {
				callback();
			}
			return;
		}
		
		let html = document.head;
		if (footer) {
			html = document.body;
		}

		const script = document.createElement('script');
		script.src = fileName;
		html.appendChild(script);
		script.onload = () => {
			if (callback) {
				callback();
			}
		};
		this._assets.js.push(fileName);
	}

	/**
	 * Private function init event
	 */
    _initEvents() {
        this.events['domready'] = new Event('domready');
        this.events['destroy'] = new Event('destroy');
	}
}


export default {
	Component: Component,
	Module: Module,
	App: App,

	registerComponent: (selector, meta) => {
		if (components.selector !== undefined) {
			throw 'Component for selector "' + selector + '" has been already registered.';
		}
		components.push({
			selector: selector,
			meta: meta
		});
	}
};
